// extracted by mini-css-extract-plugin
export default {"button":"Lo-z","reviewSort":"Mo-z"};